import { useEffect, useState } from 'react';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { useNavigate, useParams } from 'react-router-dom';
import categoryApi from '../../../../api/categories';
import LoadingContent from '../../../../components/LoadingContent';
import { SubjectForm, SubjectFormError } from '../AddSubject';
import { ISubject } from '@wot/typings';
import { Button } from '@wot/components';
import { toast } from 'react-toastify';

interface Props {
  cat: ISubject;
}

export default function EditSubject({ cat }: Props) {
  const [category, setCategory] = useState<ISubject>();
  const { _id } = useParams();
  const [errors, setErrors] = useState<SubjectFormError>();
  const navigate = useNavigate();

  useEffect(() => {
    if (_id) {
      setCategory(cat);
    }
  }, [_id]);

  if (!category) {
    return <LoadingContent />;
  }

  const updateCategory = async () => {
    if (_id) {
      if (!category || !category.name || category.grades?.length === 0 || category.board?.length === 0) {
        toast.error('Please fill out all the required fields');
        return;
      }
      const categories = await categoryApi.getCategories("subject");
      const temp = categories.filter((c) => c._id !== _id && c.category.name === category.name);
      if (temp.length > 0) {
        toast.error(`${category.name} subject already exists.`);
        return;
      }
      categoryApi
        .updateCategory({
          _id: _id,
          data: {
            category
          }
        })
        .then(() => {
          toast.success('Subject Updated');
          navigate(-1);
        })
        .catch(() => {
          toast.error('Something went wrong.');
        });
    }
  };

  return (
    <div className="w-full grow flex flex-col gap-7 p-4">
      <div className="w-full flex items-center justify-between">
        <div className="w-full flex items-center gap-4">
          <IoMdArrowRoundBack className="w-5 cursor-pointer" onClick={() => navigate(-1)} />
          <h1 className="text-xl font-semibold">Subject: {category.name}</h1>
        </div>
        <div className="max-w-xs">
          <Button
            text="Update"
            onClick={() => {
              if (!category.name || !category.board.length) {
                setErrors({
                  ...errors,
                  name: !category.name,
                  boards: category.board.length === 0
                });
                return;
              }
              setErrors(undefined);
              updateCategory();
            }}
          />
        </div>
      </div>

      <SubjectForm
        name={category.name}
        setName={(value) => setCategory({ ...category, name: value })}
        boardsList={category.board}
        setGradesList={(list) => setCategory({ ...category, grades: list })}
        gradesList={category.grades}
        setBoardsList={(list) => setCategory({ ...category, board: list })}
        errors={errors}
      />
    </div>
  );
}
